/* eslint-disable max-lines */
 
import {first} from '../../../../utils/array';
import {hasProperty, propEquals} from '../../../../utils/object';
import ko from 'knockout';
import ProductViewModel from '../../viewmodels/productviewmodel';

function SupplementProductViewModel(data, excludeFromPromo) {
    ProductViewModel.call(this, data);

    let dosingInfo,
        type = this.type(),
        MEALS_PER_DAY = 2,
        AMPM_FEEDING_TIME = '3',
        customUnitArr;

    this.isSmartPak = type === 'supplement';
    this.isPortionPak = type === 'portionpak';

    if (this.isPortionPak) {
        this.cupsPerMeal = this.dosingDescription() / MEALS_PER_DAY;
    }

    if (this.isSmartPak || this.isPortionPak) {
        dosingInfo = this.dosingInfo();

        this.doseTypes = {
            MAINTENANCE: '1997690858',
            LOADING: '1997690859',
            CUSTOM: '1997690860'
        };

        this.selectedOption = ko.observable();

        this._createDoseTypeOptionMethodsAndSubscribtions = function(type) {
            var doseType = type.toLowerCase();
            this[doseType + 'Options'] = dosingInfo.filter(propEquals('type', doseType));
            this['has' + capitalize(doseType) + 'Options'] = !!this[doseType + 'Options'].length;
            this['selected' + capitalize(doseType) + 'Option'] = ko.observable();
            this['selected' + capitalize(doseType) + 'Option'].subscribe(this.selectedOption);
        };

        Object.keys(this.doseTypes).forEach(this._createDoseTypeOptionMethodsAndSubscribtions.bind(this));

        this._createDoseTypeOptionMethodsAndSubscribtions('weight');

        this.doses = Object.keys(this.doseTypes)
            .filter(
                function(type) {
                    return this['has' + capitalize(type.toLowerCase()) + 'Options'];
                }.bind(this)
            )
            .map(
                function(type) {
                    return {
                        name: capitalize(type.toLowerCase()),
                        value: this.doseTypes[type]
                    };
                }.bind(this)
            );

        this.selectedFeedingTime = ko.observable();
        this.hasOnlyCustomOption = this.hasCustomOptions && !this.hasMaintenanceOptions && !this.hasLoadingOptions;
        this.hasSingleDoseTypeOption = this.doses.length === 1;
        this.selectedDoseTypeId = ko.observable(
            this.hasOnlyCustomOption ? this.doseTypes.CUSTOM : this.doseTypes.MAINTENANCE
        );

        this.isAutoShip = ko.observable(this.daysSupply() > 0);

        this.selectedDoseDisplayName = ko.computed(() => {
            const id = this.selectedDoseTypeId(),
                doses = this.doses.filter(d => d.value === id.toString());
            
            return doses.length ? doses[0].name : '';
        });

        this.selectedDoseTypeId.subscribe(
            function(id) {
                this.selectedFeedingTime('');
                if(this.hasCustomOptions){
                    this.selectedCustomDoseDescription('');
                }

                if (id) {
                    var type = findDoseTypeById(this.doseTypes, id).toLowerCase(),
                        name = 'selected' + capitalize(type) + 'Option';

                    this.selectedOption(this[name]() ? this[name]() : undefined);

                    if (this[type + 'Options'].length === 1) {
                        this[name](this[type + 'Options'][0]);
                    }
                }
            }.bind(this)
        );

        this.customRetailOption = this.dosingInfo()
            .filter(propEquals('type', 'customretail'))
            .map(function(info) {
                info.description(parseFloat(info.description()));
                return info;
            })[0];

        this.hasCustomRetailOption = !!this.customRetailOption;

        if (this.hasCustomOptions) {
            customUnitArr = this.customOptions.map(getProductUnitName);

            this.customUnitDescription = customUnitArr[customUnitArr.length - 1];
            this.customOptions = this.customOptions.map(function(option) {
                option.description(parseFloat(option.description()));
                return option;
            });

            this.removePluralInstance = function(unit) {
                var removePlural = unit.length - 1,
                    position = -1;

                return unit.substring(removePlural, position);
            };

            this.buildUnitDescription = function(option, selectedFeedingTime, selectedDoseTypeId) {
                var unitCount = option ? option.description() : 0,
                    feedingTime = selectedFeedingTime ? +selectedFeedingTime : 1,
                    feedingFrequency = feedingTime === +AMPM_FEEDING_TIME ? 'twice' : 'once',
                    unit =
                        unitCount === 1
                            ? this.removePluralInstance(this.customUnitDescription)
                            : this.customUnitDescription,
                    day = this.isPortionPak ? ' day' : ' daily';

                if (this.isPortionPak) {
                    feedingFrequency = 'per';
                }

                return !option || (!!option && selectedDoseTypeId !== this.doseTypes.CUSTOM)
                    ? ''
                    : unitCount + ' ' + unit + ' ' + feedingFrequency + day;
            };

            this.selectedUnitDescription = ko.computed(
                function() {
                    return this.buildUnitDescription(
                        this.selectedOption(),
                        this.selectedFeedingTime(),
                        this.selectedDoseTypeId()
                    );
                }.bind(this)
            );

            this.customRetailUnitDescription = this.hasCustomRetailOption
                ? this.buildUnitDescription(
                      this.customRetailOption,
                      this.selectedFeedingTime(),
                      this.selectedDoseTypeId()
                  )
                : '';

            this.selectedCustomDoseDescription = ko.observable();
            this.selectedCustomDoseDescription.subscribe(
                function(description) {
                    this.selectedCustomOption(
                        first(this.customOptions, function(option) {
                            return option.description() === parseFloat(description);
                        })
                    );
                }.bind(this)
            );
        }

        this.selectedPriceModel = ko.computed(
            function() {
                var option =
                    this.hasOnlyCustomOption && !this.selectedOption()
                        ? this.customRetailOption
                        : this.selectedOption();
                return option ? option.price : this.price;
            }.bind(this)
        );

        this.autoShipSavings = ko.computed(
            function() {
                var priceModel = this.selectedPriceModel();

                return hasProperty(priceModel, 'autoShipDiscount.saving')
                    ? priceModel.autoShipDiscount.saving()
                    : 0;
            }.bind(this)
        );

        this.hasAutoShipSavings = ko.computed(
            function() {
                return this.isAutoShip() && this.autoShipSavings() > 0;
            }.bind(this)
        );

        this.costBeforeAutoShip = ko.computed(
            function() {
                var price = convertCostToNumber(this.selectedPriceModel().current());

                if (this.selectedFeedingTime() === AMPM_FEEDING_TIME) {
                    price = price * 2;
                }

                return price.toFixed(2);
            }.bind(this)
        );

        this.costPerDayBeforeAutoShip = ko.computed(
            function() {
                return (this.costBeforeAutoShip() / this.daysSupply()).toFixed(2);
            }.bind(this)
        );

        this.originalCostBeforeAutoShip = ko.computed(
            function() {
                var price = convertCostToNumber(this.selectedPriceModel().original());

                if (this.selectedFeedingTime() === AMPM_FEEDING_TIME) {
                    price = price * 2;
                }

                return price.toFixed(2);
            }.bind(this)
        );

        this.originalCostAfterAutoShip = ko.computed(
            function() {
                var priceModel = this.selectedPriceModel(),
                    price = convertCostToNumber(priceModel.original());

                if (this.hasAutoShipDiscount) {
                    price = price * ((100 - priceModel.autoShipDiscount.percentOff()) / 100);
                }

                if (this.selectedFeedingTime() === AMPM_FEEDING_TIME) {
                    price = price * 2;
                }

                return price.toFixed(2);
            }.bind(this)
        );

        this.originalCostPerDayBeforeAutoShip = ko.computed(
            function() {
                var price = convertCostToNumber(this.selectedPriceModel().original());

                return (price / this.daysSupply()).toFixed(2);
            }.bind(this)
        );

        this.costAfterAutoShip = ko.computed(
            function() {
                var priceModel = this.selectedPriceModel(),
                    price = convertCostToNumber(priceModel.current());

                if (this.hasAutoShipDiscount) {
                    price = price - priceModel.autoShipDiscount.saving();
                }

                if (this.selectedFeedingTime() === AMPM_FEEDING_TIME) {
                    price = price * 2;
                }

                return price.toFixed(2);
            }.bind(this)
        );

        this.costPerDayAfterAutoShip = ko.computed(
            function() {
                return (this.costAfterAutoShip() / this.daysSupply()).toFixed(2);
            }.bind(this)
        );

        this.cost = ko.computed(
            function() {
                var priceModel = this.selectedPriceModel(),
                    price = convertCostToNumber(priceModel.current());

                if (this.hasAutoShipSavings()) {
                    price = price - priceModel.autoShipDiscount.saving();
                }

                if (this.selectedFeedingTime() === AMPM_FEEDING_TIME) {
                    price = price * 2;
                }

                return price.toFixed(2);
            }.bind(this)
        );

        this.costPerDay = ko.computed(
            function() {
                return (this.cost() / this.daysSupply()).toFixed(2);
            }.bind(this)
        );

        if (this.hasMaintenanceOptions) {
            this.selectedOption(this.maintenanceOptions[0]);
        }
    }

    if (this.isTes) {
        this.isAutoShip = ko.observable(this.hasDaysSupply());

        this.daysSupplyInput = ko.observable(this.hasDaysSupply() ? this.daysSupply() : '');

        this.daysSupplyInput.subscribe(
            function() {
                if (!this.customerIsSmartPrimeEligible && this.isInvalidPerksEligibleItem()) {
                    showPerksEligibleWarningModal();
                }
            }.bind(this)
        );

        this.hasAutoShipSavings = ko.computed(
            function() {
                var priceModel = this.price;
                return (
                    !excludeFromPromo &&
                    this.isAutoShip() &&
                    hasProperty(priceModel, 'autoShipDiscount.saving') &&
                    priceModel.autoShipDiscount.saving() > 0
                );
            }.bind(this)
        );

        this.costBeforeAutoShip = ko.computed(
            function() {
                var price = convertCostToNumber(this.price.current());

                return price.toFixed(2);
            }.bind(this)
        );

        this.costPerDayBeforeAutoShip = ko.computed(
            function() {
                var price = convertCostToNumber(this.price.current());

                return (price / this.daysSupply()).toFixed(2);
            }.bind(this)
        );

        this.originalCostBeforeAutoShip = ko.computed(
            function() {
                var price = convertCostToNumber(
                    this.price.type() === 'base' ? this.price.current() : this.price.original()
                );

                return price.toFixed(2);
            }.bind(this)
        );

        this.originalCostPerDayBeforeAutoShip = ko.computed(
            function() {
                var price = convertCostToNumber(
                    this.price.type() === 'base' ? this.price.current() : this.price.original()
                );

                return (price / this.daysSupply()).toFixed(2);
            }.bind(this)
        );

        this.originalCostAfterAutoShip = ko.computed(
            function() {
                var priceModel = this.price,
                    price = convertCostToNumber(
                        priceModel.type() === 'base' ? priceModel.current() : priceModel.original()
                    );

                if (this.hasAutoShipDiscount) {
                    price = price * ((100 - priceModel.autoShipDiscount.percentOff()) / 100);
                }

                return price.toFixed(2);
            }.bind(this)
        );

        this.costAfterAutoShip = ko.computed(
            function() {
                var priceModel = this.price,
                    price = convertCostToNumber(priceModel.current());

                if (this.hasAutoShipDiscount) {
                    price = price - priceModel.autoShipDiscount.saving();
                }

                return price.toFixed(2);
            }.bind(this)
        );

        this.costPerDayAfterAutoShip = ko.computed(
            function() {
                return (this.costAfterAutoShip() / this.daysSupply()).toFixed(2);
            }.bind(this)
        );

        this.cost = ko.computed(
            function() {
                var priceModel = this.price,
                    price = convertCostToNumber(priceModel.current());

                if (this.hasAutoShipSavings()) {
                    price = price - priceModel.autoShipDiscount.saving();
                }

                return price.toFixed(2);
            }.bind(this)
        );

        this.costPerDay = ko.computed(
            function() {
                return (this.cost() / this.daysSupply()).toFixed(2);
            }.bind(this)
        );

        if (this.cupsOfProduct) {
            this.daysSupplyOfProduct = Math.round(this.cupsOfProduct() / 2);
        }

        if (this.hasDaysSupply()) {
            this.isAutoShip(true);
        }

        this.increaseQuantity = function() {
            this.quantity(+this.quantity() + 1);
        };

        this.decreaseQuantity = function() {
            this.quantity(+this.quantity() > 1 ? +this.quantity() - 1 : 1);
        };
    }

    this.packagingOption = this.isSmartPak ? 'SmartPaks' : this.isPortionPak ? "PortionPaks" : this.displayName();
}

function getProductUnitName(item) {
    return item.description().split(/\s/)[1];
}

function convertCostToNumber(str) {
    return +(/^\$/.test(str) ? str.substring(1) : str);
}

function capitalize(str) {
    return str.substring(0, 1).toUpperCase() + str.substring(1);
}

function findDoseTypeById(types, id) {
    return first(Object.keys(types), function(type) {
        return types[type] === id;
    });
}

function showPerksEligibleWarningModal() {
    var $element = $('.frequency');

    smartPak.ui.modal($element.get(0), {
        title: "Head's Up!"
    });
}

export default SupplementProductViewModel;
